import { gridInfoProps } from '@/screensComponents/Insurances/TableBlock/styles'

export const gridInfo: gridInfoProps = {
	title: 'Программы страхования',
	gridList: [
		{
			logo: {
				imgSRC: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/Insurance/vsk.png',
				height: 45,
				width: 130
			},
			name: {
				title: 'полис «Защита техники 2 года»',
				subtitle: 'Защита покупки на случай механических повреждений'
			},
			time: { title: 'Период', subtitle: '2 года' },
			insuranceSum: { title: 'Страховая сумма', subtitle: '100%' },
			price: { title: 'Стоимость', subtitle: '≈22% - 26%' },
			nodeList: [
				{
					title: 'От чего защищает этот полис?',
					list: [
						'Механическое повреждение (случайное повреждение из-за ненадлежащего обращения в результате неожиданного или случайного внешнего события)',
						'Воздействие жидкости / конденсат'
					]
				},
				{
					title: 'Что можно застраховать?',
					list: ['iPhone', 'iPad', 'Apple Watch', 'MacBook', 'iMac']
				},
				{
					title: 'Условия и сроки:',
					list: [
						'2 обращения в пределах страховой суммы',
						'Страховая сумма 100 % стоимости имущества',
						'Стоимость устройства до 500 000 руб',
						'Срок действия полиса с шестнадцатого дня после приобретения устройства'
					]
				}
			]
		},
		{
			logo: {
				imgSRC: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/Insurance/vsk.png',
				height: 45,
				width: 130
			},
			name: {
				title: 'полис «Срок службы плюс»',
				subtitle: 'Продленная гарантия'
			},
			time: { title: 'Период', subtitle: '3 года и 5 лет' },
			insuranceSum: { title: 'Страховая сумма', subtitle: '100%' },
			price: { title: 'Стоимость', subtitle: '8% - 10%' },
			nodeList: [
				{
					title: 'От чего защищает этот полис?',
					list: [
						'Воздействие электроэнергии (перепады напряжения). Действует первый год.',
						'Поломка в постгарантийный период (причины аналогичные причинам на гарантии у производителя)'
					]
				},
				{
					title: 'Что можно застраховать?',
					list: [
						'iPhone',
						'iPad',
						'Apple Watch',
						'MacBook',
						'iMac',
						'AirPods',
						'Телевизоры',
						'Наушники',
						'Бытовая техника',
						'Мультимедиа'
					]
				},
				{
					title: 'Условия и сроки:',
					list: [
						'Неограниченное количество обращений в пределах страховой суммы',
						'Страховая сумма 100 % стоимости имущества',
						'Стоимость устройства до 1 000 000 руб',
						'Срок действия полиса с шестнадцатого дня после приобретения устройства'
					]
				}
			]
		},
		{
			logo: {
				imgSRC: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/Insurance/vsk.png',
				height: 45,
				width: 130
			},
			name: {
				title: 'полис «Техника в безопасности»',
				subtitle: 'Защита покупки на случай внешних повреждений и других рисков'
			},
			time: { title: 'Период', subtitle: '1 год' },
			insuranceSum: { title: 'Страховая сумма', subtitle: '100%' },
			price: { title: 'Стоимость', subtitle: '≈17%' },
			nodeList: [
				{
					title: 'От чего защищает этот полис?',
					list: [
						'Механическое повреждение',
						'Воздействие жидкости / конденсат',
						'Пожар, взрыв, удар молнии',
						'Стихийные бедствия',
						'Разбой, грабеж, хулиганство, кража, теракт',
						'Падение посторонних предметов',
						'Воздействия в результате ДТП',
						'Воздействие электроэнергии (перепады напряжения)'
					]
				},
				{
					title: 'Что можно застраховать?',
					list: [
						'iPhone',
						'iPad',
						'Apple Watch',
						'MacBook',
						'iMac',
						'AirPods',
						'Телевизоры',
						'Наушники',
						'Бытовая техника',
						'Мультимедиа'
					]
				},
				{
					title: 'Условия и сроки:',
					list: [
						'Неограниченное количество в пределах страховой суммы',
						'Страховая сумма 100 % стоимости имущества',
						'Стоимость устройства до 1 000 000 руб',
						'Срок действия полиса с шестнадцатого дня после приобретения устройства'
					]
				}
			]
		},
		{
			logo: {
				imgSRC: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/Insurance/vsk.png',
				height: 45,
				width: 130
			},
			name: {
				title: 'полис «Сверх возможности»',
				titleNotation: 'Полис включает в себя две программы: «Техника в безопасности» и «Срок службы плюс»',
				subtitle: 'Защита покупки в первый год и продлённая гарантия в последующий период'
			},
			time: {
				title: 'Период',
				subtitle: '1 год и 3 - 5 лет',
				subtitleNotation: '1 год для полиса «Техника в безопасности» и 3 и 5 лет для «Срок службы плюс»'
			},
			insuranceSum: { title: 'Страховая сумма', subtitle: '100%' },
			price: { title: 'Стоимость', subtitle: '≈21% - 22%' },
			nodeList: [
				{
					title: 'От чего защищает этот полис?',
					list: [
						'Механическое повреждение',
						'Воздействие жидкости / конденсат',
						'Пожар, взрыв, удар молнии',
						'Стихийные бедствия',
						'Разбой, грабеж, хулиганство, кража, теракт',
						'Падение посторонних предметов',
						'Воздействия в результате ДТП',
						'Воздействие электроэнергии (перепады напряжения)',
						'Поломка в постгарантийный период (причины аналогичные причинам по гарантии у производителя)'
					]
				},
				{
					title: 'Что можно застраховать?',
					list: [
						'iPhone',
						'iPad',
						'Apple Watch',
						'MacBook',
						'iMac',
						'AirPods',
						'Телевизоры',
						'Наушники',
						'Бытовая техника',
						'Мультимедиа'
					]
				},
				{
					title: 'Условия и сроки:',
					list: [
						'Неограниченное количество в пределах страховой суммы',
						'Страховая сумма 100 % стоимости имущества',
						'Стоимость устройства до 1 000 000 руб',
						'Срок действия полиса с шестнадцатого дня после приобретения устройства'
					]
				}
			]
		},
		{
			logo: {
				imgSRC: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/Insurance/alfa.png',
				height: 22,
				width: 130
			},
			name: {
				title: 'полис «Защита покупки»',
				subtitle: 'Защита покупки на случай внешних повреждений и других рисков'
			},
			time: {
				title: 'Период',
				subtitle: '1 год'
			},
			insuranceSum: {
				title: 'Страховая сумма',
				subtitle: '100%'
			},
			price: {
				title: 'Стоимость',
				subtitle: '14% - 18%'
			},
			nodeList: [
				{
					title: 'От чего защищает этот полис?',
					list: [
						'Механическое повреждение',
						'Воздействие жидкости / конденсат',
						'Пожар, взрыв, удар молнии',
						'Стихийные бедствия',
						'Разбой, грабеж, хулиганство, кража, теракт',
						'Падение посторонних предметов',
						'Воздействия в результате ДТП',
						'Воздействие электроэнергии (перепады напряжения)'
					]
				},
				{
					title: 'Что можно застраховать?',
					list: ['iPhone', 'iPad', 'Apple Watch']
				},
				{
					title: 'Условия и сроки:',
					list: [
						'Неограниченное количество в пределах страховой суммы',
						'Страховая сумма 100 % стоимости имущества',
						'Стоимость устройства до 300 000 руб',
						'Срок действия полиса с шестнадцатого дня после приобретения устройства',
						'В случае невозможности ремонта выплачивается 80% страховой суммы'
					]
				}
			]
		},
		{
			logo: {
				imgSRC: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/Insurance/alfa.png',
				height: 22,
				width: 130
			},
			name: {
				title: 'полис «Экран под защитой»',
				subtitle: 'Защита дисплея от механических повреждений'
			},
			time: {
				title: 'Период',
				subtitle: '1 год'
			},
			insuranceSum: {
				title: 'Страховая сумма',
				subtitle: '50%'
			},
			price: {
				title: 'Стоимость',
				subtitle: '7,5%'
			},
			nodeList: [
				{
					title: 'От чего защищает этот полис?',
					list: ['Механическое повреждение дисплея']
				},
				{
					title: 'Что можно застраховать?',
					list: ['iPhone', 'iPad']
				},
				{
					title: 'Условия и сроки:',
					list: [
						'Неограниченное количество в пределах страховой суммы',
						'Страховая сумма 50 % стоимости имущества',
						'Стоимость устройства до 300 000 руб',
						'Срок действия полиса с шестнадцатого дня после приобретения устройства',
						'В случае невозможности ремонта выплачивается 80% страховой суммы'
					]
				}
			]
		}
	]
}
